export default __webpack_public_path__ + "static/media/logo-usdt.13ff7f0c.svg";